import { Clipboard } from "@angular/cdk/clipboard";
import {
	STEPPER_GLOBAL_OPTIONS,
	StepperSelectionEvent
} from "@angular/cdk/stepper";
import { DecimalPipe } from "@angular/common";
import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	HostListener,
	OnInit,
	ViewChild
} from "@angular/core";
import {
	UntypedFormArray,
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators
} from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import {
	map,
	Observable,
	startWith,
	Subject,
	Subscription,
	takeUntil
} from "rxjs";
import { FileFunction } from "src/app/share/function/file.function";
import { ValidatorFunction } from "src/app/share/function/validator.function";
import { AlertService } from "src/app/share/service/alert.service";
import {
	PAYMENT_OPTION_ATOME,
	PAYMENT_OPTION_BNPL,
	PAYMENT_OPTION_EPP,
	PAYMENT_OPTION_EPP_3_6_12_MONTHS,
	PAYMENT_OPTION_EPP_6_12_MONTHS,
	PAYMENT_OPTION_EWALLET,
	PAYMENT_OPTION_FP,
	PAYMENT_OPTION_FPX,
	PAYMENT_OPTION_FPX_ENTERPRISE,
	PAYMENT_OPTION_PAYEX,
	PAYMENT_OPTION_RAZER,
	PAYMENT_OPTION_SHOPBACK,
	PAYMENT_OPTION_VISA
} from "../share/constants/payment-options";
import { SubmitSuccessDialogComponent } from "../share/dialog/submit-success-dialog/submit-success-dialog.component";
import {
	getAddOnPrice,
	getPaymentValues
} from "../share/function/pricing.function";
import { FieldData } from "../share/interface/common.interface";
import {
	MotorQuotationInterface,
	OtherInsurerInterface
} from "../share/interface/motor/motor-quotation.interface";
import {
	IPaymentData,
	IPaymentValues
} from "../share/interface/payment.interface";
import { DrawerService } from "../share/service/drawer.service";
import { SignalrService } from "../share/service/signalr.service";
import { TimerService } from "../share/service/timer.service";
import { OrderDataService } from "./data-service/order-data.service";
import {
	BNPLRateListInterface,
	GeneraliGetOrderInfoInterface,
	MotorAddOnCARTPriceInterface,
	ProductAddOnInterface,
	PromoCodeInterface,
	QuotationInterface
} from "./interface/motor-quotation.interface";
import { BenefitDialogComponent } from "./ui/benefit-dialog/benefit-dialog.component";
import { CarDetailsDialogComponent } from "./ui/car-details-dialog/car-details-dialog.component";
import { CarPlanDialogComponent } from "./ui/car-plan-dialog/car-plan-dialog.component";
import { CarVariantDialogComponent } from "./ui/car-variant-dialog/car-variant-dialog.component";
import { DealerCaseDialogComponent } from "./ui/dealer-case-dialog/dealer-case-dialog.component";
import { EditQuotationsNewComponent } from "./ui/edit-quotations-new/edit-quotations-new.component";
import { PaymentOptionsComponent } from "./ui/payment-options/payment-options.component";
import { ThankyouPurchaseDialogComponent } from "./ui/thankyou-purchase-dialog/thankyou-purchase-dialog.component";

@Component({
	selector: "app-comparison",
	templateUrl: "./comparison.component.html",
	styleUrls: ["./comparison.component.scss"],
	providers: [
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { displayDefaultIndicatorType: false }
		},
		DecimalPipe
	]
})
export class ComparisonComponent implements OnInit {
	@ViewChild("stepper") stepper: MatStepper;
	@ViewChild("paymentOption") paymentOption: PaymentOptionsComponent;

	screenWidth: number;
	maxAdditionalDriver: number;
	fgapPriceList: number[];
	numberOfLltpSeats: number = 0;

	dailyAndAnnual: boolean = false;

	partnerCode: string;
	dealerRepId: string;
	id: string;
	quotationId: string;
	promoCode: string;
	promoError: string;
  promoMinAmount: number;
  promoMaxAmount: number;
	paymentOptionShopback: string = PAYMENT_OPTION_SHOPBACK;
	paymentOptionEpp: string = PAYMENT_OPTION_EPP;
	paymentOptionFpx: string = PAYMENT_OPTION_FPX;
	paymentOptionAtome: string = PAYMENT_OPTION_ATOME;
	paymentOptionBNPL: string = PAYMENT_OPTION_BNPL;
	fgapAddOnsIndex: string = "0";
	addOnOptionalCategory: string[] = [];
	dealerOutletsList: string[] = ["Others"];
	filteredHirePurchase: Observable<string[]>;
	filteredDealerOutletsList: Observable<string[]>;
	stateList: string[] = [
		"Selangor",
		"Kuala Lumpur",
		"Johor",
		"Kedah",
		"Kelantan",
		"Melaka",
		"Negeri Sembilan",
		"Pahang",
		"Perak",
		"Perlis",
		"Pulau Pinang",
		"Sarawak",
		"Sabah",
		"Terengganu"
	];
	filterStateList: string[] = Object.assign([], this.stateList);
	filterDeliveryStateList: string[] = Object.assign([], this.stateList);
	otherInsurersList: string[] = [
		"Allianz",
		"am",
		"greateastern",
		"kurnia",
		"liberty",
		"longpac",
		"Msig",
		"Rhb",
		"tokio"
	];

	isFloodChecked: boolean;
	isVBETChecked: boolean;
	isDriverChecked: boolean;
	isSameAddressCheck: boolean;
	includeDigitalRoadTax: boolean;
	showRoadTaxList: boolean = false;
	isIncludeDigitalRoadtax: boolean = false;
	isStep2Valid: boolean = false;
	allowEditQuotation: boolean = false;
	isApplyDraft: boolean = false;
	isInitialLanding: boolean = true;
	isVehicleTypeMotorcycle: boolean = false;
	isPAPlanGeneraliMotorcycleChecked: boolean = false;

	quotationFrmGroup: UntypedFormGroup;
	addOnFrmGroup: UntypedFormGroup;
	infoFrmGroup: UntypedFormGroup;
	agreementFrmGroup: UntypedFormGroup;
	paymentFrmGroup: UntypedFormGroup;

	requestData: any;
	windshieldMin: any;
	windshieldMax: any;
	quotationList: any[] = [];
	quotationListAvailable: any[] = [];
	addOnList: any[] = [];
	selectedAddOn: any = [];
	selectedNonSSTAddOnToDisplay: any[] = [];
	productDocumentInterface: any[] = [];
	uniquePageView: any[] = [
		{
			index: 0,
			pageTitle: "comparison page"
		},
		{
			index: 1,
			pageTitle: "add ons page"
		},
		{
			index: 2,
			pageTitle: "user details page"
		},
		{
			index: 3,
			pageTitle: "order summary page"
		}
	];
	relationshipList = [
		{ id: "Parent/Parent-in-law", name: "common.parents" },
		{ id: "Spouse", name: "common.spouse" },
		{ id: "Son/Daughter", name: "common.child" },
		{ id: "Sibling/Sibling-in-law/Cousin/Relative", name: "common.sibling" },
		{ id: "Friend/Co-worker", name: "common.friend" }
	];
	hirePurchaseList = [];
	bnplRateList: BNPLRateListInterface[] = [];

	idTypeList: FieldData[] = [
		{ codeValue: "IC_NO", codeDesc: "IC Number" },
		{ codeValue: "PASSPORT", codeDesc: "Passport" },
		{ codeValue: "POLICE/ARMY", codeDesc: "Police/Army" }
	];

	cartDayList: FieldData[] = [
		{ codeValue: "7", codeDesc: "7" },
		{ codeValue: "14", codeDesc: "14" },
		{ codeValue: "21", codeDesc: "21" }
	];

	cartDailyCoverageList: FieldData[] = [
		{ codeValue: "50", codeDesc: "RM 50" },
		{ codeValue: "100", codeDesc: "RM 100" },
		{ codeValue: "200", codeDesc: "RM 200" }
	];

	cartAddOnPriceList: MotorAddOnCARTPriceInterface[] = [];
	selectedCartDays: string;
	selectedCartDailyCoverage: string;
	minGCKTCoverage: number = 0;
	minVACoverage: number = 0;

	// images
	mykadOrPassport: any[] = [];
	letterOfUndertaking: any[] = [];
	vehiclePhoto: any[] = [];
	vehicleInteriorPhoto: any[] = [];
	vehicleVideo: any[] = [];

	selectedQuotation: QuotationInterface;
	quotationToPrint: QuotationInterface;
	includeAddOnList: ProductAddOnInterface[] = [];
	UnlimitedTowing_Motorcycle: ProductAddOnInterface;
	paymentData: IPaymentData = {
		bank: null,
		ewalletType: null,
		fpxEnterpriseType: null,
		installmentMonth: null,
		paymentChannel: PAYMENT_OPTION_FPX,
		paymentProvider: PAYMENT_OPTION_RAZER,
		paymentType: PAYMENT_OPTION_FP,
		formIsValid: true,
		eppRate: 0,
		paymentOptionType: PAYMENT_OPTION_FP
	};
	promo: PromoCodeInterface;

	// Insurer Flags
	isAllianzQuotation: boolean = false;

	// ewpMileagePrice: number = 0;
	// ewpMileageMax: number = 0;

	// ewpFiles = {
	// 	mileageImage: [],
	// 	vehRegCard: [],
	// 	vehInsReport: [],
	// };

	maxDob: Date = new Date();
	currentDate: Date = new Date();
	// Insurance placeholder
	selectedOtherInsurers: string[] = [];
	otherInsurerList: OtherInsurerInterface[] = [];
	private timerSubscription: Subscription | null = null;
	private timerUnsubscribe$ = new Subject<void>();

	isGeneraliIQ: boolean = false;
	isChubbIQ: boolean = false;
	benefitsExpanded: boolean = false;

	constructor(
		private elRef: ElementRef,
		private clipboard: Clipboard,
		public translate: TranslateService,
		private alertService: AlertService,
		private formBuilder: UntypedFormBuilder,
		private activatedRoute: ActivatedRoute,
		private ngxSpinnerService: NgxSpinnerService,
		private orderDataService: OrderDataService,
		private router: Router,
		private dialog: MatDialog,
		public drawerService: DrawerService,
		private _decimalPipe: DecimalPipe,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		public signalRService: SignalrService,
		private cd: ChangeDetectorRef,
		private timerService: TimerService
	) {
		this.screenWidth = window.innerWidth;
		this.id = activatedRoute.snapshot.params.id;

		this.initQuotationForm();
		this.initAddOnForm();
		this.initInfoForm();
		this.initAgreementForm();
		this.initPaymentForm();

		this.signalRService.startConnection().subscribe((isConnected) => {
      
      this.signalRService.joinUserGroup(this.activatedRoute.snapshot.params.id.toString());
      this.signalRService.registerUserGroupMessageListener();
      this.signalRService.registerGroupJoinedListener();
			this.updateQuotationMethod(isConnected);
    });

		if (this.isUUID(this.id)) {
			this.allowEditQuotation =
				activatedRoute.snapshot.queryParams.editQuotation;
			this.getDetailById();
		} else {
			window.location.href = "/";
		}
		this.translate.onLangChange.subscribe((x) => {
			if (this.selectQuotation) {
				this.getProductDocument();
			}
		});
	}

	ngOnInit(): void {
		this.getAdditionalInsurer();
	}

	ngOnDestroy(): void {
		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
		this.timerUnsubscribe$.next();
		this.timerUnsubscribe$.complete();
	}

	ngAfterViewChecked(): void {
		//The if logic is so that we don't run the code if stepper doesn't exist yet and there's no draft data.
		//Alternatively, you can just check if the draft data is not null instead of having the isFromDraft variable.
		if (this.stepper && this.isApplyDraft && this.isInitialLanding) {
			//In order to move steps, ALL steps that has a stepControl must be VALID
			this.isStep2Valid = true;
			this.stepper.next();

			if (
				this.isInitialLanding &&
				this.stepper.selectedIndex == this.stepper.steps.length - 1
			) {
				this.isInitialLanding = false;
			}
		}

		//This is needed to only trigger change detection. Note at the constructor is where it's imported
		this.cdr.detectChanges();
	}

	@HostListener("window:resize", ["$event"])
	onResize(event) {
		this.screenWidth = event.target.innerWidth;
	}

	private initQuotationForm() {
		this.quotationFrmGroup = new UntypedFormGroup({
			id: new UntypedFormControl(this.quotationId, [Validators.required])
		});
	}

	private initAddOnForm() {
		this.getCARTAddOnPriceList();

		this.addOnFrmGroup = new UntypedFormGroup({
			windshield: new UntypedFormControl(),
			drivers: new UntypedFormArray([]),
			roadTaxPrice: new UntypedFormControl(this.requestData?.roadTaxPrice),
			fgap: new UntypedFormControl(),
			// ewp: new FormControl(),
			isIncludeRoadtax: new UntypedFormControl(),
			isNotBlacklisted: new UntypedFormControl(null),
			isWindshieldExceeded: new UntypedFormControl(null),
			lltpSeats: new UntypedFormControl(this.numberOfLltpSeats[0]),
			cartDays: new UntypedFormControl(),
			cartDailyCoverage: new UntypedFormControl(),
			gckt: new UntypedFormControl(),
			va: new UntypedFormControl()
		});

		this.addOnFrmGroup.valueChanges.subscribe(() => {
			this.applyPromoCode();
		});

		this.addOnFrmGroup.controls.isIncludeRoadtax.valueChanges.subscribe((x) => {
			let validators = [];
			let addressValidators = [];
			if (x) {
				validators = [Validators.requiredTrue];
				addressValidators = [Validators.required];
				this.infoFrmGroup.controls.deliveryPostcode.enable();
			} else {
				this.addOnFrmGroup.controls.isNotBlacklisted.reset();
				this.infoFrmGroup.controls.deliveryPostcode.enable();
			}
			this.addOnFrmGroup.controls.isNotBlacklisted.setValidators(validators);
			this.addOnFrmGroup.controls.isNotBlacklisted.updateValueAndValidity();

			// this.infoFrmGroup.controls.deliveryAddress.setValidators(
			// 	addressValidators,
			// );
			// this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();

			// this.infoFrmGroup.controls.deliveryAddress2.setValidators(
			// 	addressValidators,
			// );
			// this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();

			// this.infoFrmGroup.controls.deliveryCity.setValidators(addressValidators);
			// this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();

			// this.infoFrmGroup.controls.deliveryPostcode.setValidators(
			// 	addressValidators,
			// );
			// this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();

			// this.infoFrmGroup.controls.deliveryState.setValidators(addressValidators);
			// this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
		});
		this.addOnFrmGroup.get("windshield")?.valueChanges.subscribe(() => {
			this.clearPromoCode();
		});

		this.addOnFrmGroup.controls.cartDays.valueChanges.subscribe((x) => {
			if (x) {
				this.selectedCartDays = x;
			}
		});

		this.addOnFrmGroup.controls.cartDailyCoverage.valueChanges.subscribe(
			(x) => {
				if (x) {
					this.selectedCartDailyCoverage = x;
				}
			}
		);
	}

	private initInfoForm() {
		let initialUserData = {
			name: null,
			occupation: null,
			mobileNo: null,
			email: null,
			address: null,
			address2: null,
			city: null,
			postcode: null,
			state: null
		};

		if (process.env.NODE_ENV === "development") {
			initialUserData = {
				name: "TEST DEV NAME",
				occupation: "TEST DEV OCCUPATION",
				mobileNo: "123456789",
				email: "testdev@email.com",
				address: "TEST ADDRESS 1",
				address2: "TEST ADDRESS 2",
				city: "TEST CITY",
				postcode: "11111",
				state: "Selangor"
			};
		}

		this.infoFrmGroup = new UntypedFormGroup({
			name: new UntypedFormControl(initialUserData.name, [Validators.required]),
			occupation: new UntypedFormControl(initialUserData.occupation, []),
			mobileNo: new UntypedFormControl(initialUserData.mobileNo, [
				Validators.required
			]),
			email: new UntypedFormControl(initialUserData.email, [
				Validators.required,
				Validators.email
			]),
			address: new UntypedFormControl(initialUserData.address, [
				Validators.required
			]),
			address2: new UntypedFormControl(initialUserData.address2, [
				Validators.required
			]),
			city: new UntypedFormControl(initialUserData.city, [Validators.required]),
			postcode: new UntypedFormControl(initialUserData.postcode, [
				Validators.required
			]),
			state: new UntypedFormControl(initialUserData.state, [
				Validators.required
			]),

			financingType: new UntypedFormControl("BankLoan", [Validators.required]),
			bank: new UntypedFormControl(""),
			effectiveDate: new UntypedFormControl(null, [Validators.required]),
			dealerCase: new UntypedFormControl(false, [Validators.required]),
			dealerOutlets: new UntypedFormControl(null),
			customDealerOutlet: new UntypedFormControl(null),

			deliveryAddress: new UntypedFormControl(null),
			deliveryAddress2: new UntypedFormControl(null),
			deliveryCity: new UntypedFormControl(null),
			deliveryPostcode: new UntypedFormControl(null),
			deliveryState: new UntypedFormControl(null)
		});
		this.infoFrmGroup.controls.postcode.disable();

		// Delete bank/hirepurchaselist if cash is selected
		this.infoFrmGroup.controls.financingType.valueChanges.subscribe((value) => {
			if (value == "Cash") {
				this.infoFrmGroup.patchValue({
					bank: null
				});
			}
		});

		// Dealer outlet required if its a dealer case
		this.infoFrmGroup.controls.dealerCase.valueChanges.subscribe((value) => {
			if (value == true) {
				this.infoFrmGroup.controls.dealerOutlets.setValidators([
					Validators.required
				]);
			} else {
				this.infoFrmGroup.controls.dealerOutlets.clearValidators();
				this.infoFrmGroup.controls.customDealerOutlet.clearValidators();
			}
			this.infoFrmGroup.controls.dealerOutlets.updateValueAndValidity();
			this.infoFrmGroup.controls.customDealerOutlet.updateValueAndValidity();
		});

		// Custom dealer case required if Others is picked on dealer outlet
		this.infoFrmGroup.controls.dealerOutlets.valueChanges.subscribe((value) => {
			if (this.infoFrmGroup.value.dealerCase && value == "Others") {
				this.infoFrmGroup.controls.customDealerOutlet.setValidators([
					Validators.required
				]);
			} else {
				this.infoFrmGroup.controls.customDealerOutlet.clearValidators();
			}

			this.infoFrmGroup.controls.customDealerOutlet.updateValueAndValidity();
		});
	}

	private initAgreementForm() {
		this.agreementFrmGroup = new UntypedFormGroup({
			agreeInfo: new UntypedFormControl(false, [Validators.requiredTrue]),
			doc: new UntypedFormArray([]),
			marketingConsent: new UntypedFormControl(false)
		});
	}

	private initPaymentForm() {
		this.paymentFrmGroup = new UntypedFormGroup({
			payment: new UntypedFormControl(false, Validators.requiredTrue)
		});

		this.getBNPLRateList();
	}

	private getBNPLRateList() {
		this.orderDataService.getBNPLRateListByPortal("a2c").subscribe({
			next: (x: BNPLRateListInterface[]) => {
				this.bnplRateList = x;
			}
		});
	}

	private isUUID(uuid: string) {
		return uuid.match(
			"^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
		);
	}

	private getDetailById() {
		this.ngxSpinnerService.show();
		this.orderDataService.getDetailById(this.id).subscribe({
			next: (x: any) => {
				this.ngxSpinnerService.hide();
				this.translate.use(x.language);
				this.requestData = x;
				this.isVehicleTypeMotorcycle = this.requestData.vehicleType == "Motorcycle" ? true : false;
				this.addOnFrmGroup.controls.roadTaxPrice.setValue(x?.roadTaxPrice);
				this.partnerCode = this.requestData.partnerCode;
				this.getQuotation();
				this.infoFrmGroup.controls.name.setValue(x.name);
				this.dealerRepId = x.dealerRepId;
				this.infoFrmGroup.controls.email.setValue(x.email);

				this.infoFrmGroup.controls.mobileNo.setValue(x.mobileNo);

				this.infoFrmGroup.controls.postcode.setValue(x.postcode);

				if (x && (x.businessType == "TransferOwnership" || x.businessType == "NewRegister")) {
					this.infoFrmGroup
						.get("financingType")
						.setValidators(Validators.required);
					this.infoFrmGroup
						.get("effectiveDate")
						.setValidators(Validators.required);
					this.infoFrmGroup
						.get("dealerCase")
						.setValidators(Validators.required);
				} else {
					this.infoFrmGroup.get("financingType").clearValidators();
					this.infoFrmGroup.get("effectiveDate").clearValidators();
					this.infoFrmGroup.get("dealerCase").clearValidators();
				}
				this.infoFrmGroup.get("financingType").updateValueAndValidity();
				this.infoFrmGroup.get("effectiveDate").updateValueAndValidity();
				this.infoFrmGroup.get("dealerCase").updateValueAndValidity();
				this.numberOfLltpSeats = x.seat;
				if (this.numberOfLltpSeats <= 4) {
					this.numberOfLltpSeats = 5;
				}
			},
			error: () => {
				// this.closeDrawer();
				this.ngxSpinnerService.hide();
				window.location.href = "/";
			}
		});
	}

	private getQuotation() {
		this.ngxSpinnerService.show();
		this.orderDataService
			.getQuotationById(this.id, this.partnerCode)
			.subscribe({
				next: (x) => {
					this.ngxSpinnerService.hide();
					this.quotationList = x;
					this.quotationListAvailable = x.filter(
						(q) => q.status === "Available"
					);
					if (this.activatedRoute.snapshot.queryParams.id) {
						setTimeout(() => {
							this.selectQuotation(this.activatedRoute.snapshot.queryParams.id);
						}, 100);
					}
					if (this.allowEditQuotation) {
						this.editQuotation();
						this.allowEditQuotation = false;
					}
				},
				error: () => {
					this.ngxSpinnerService.hide();
					window.location.href = "/";
				}
			});
	}

	private getAddOn() {
		this.ngxSpinnerService.show();
		this.includeAddOnList = [];
		this.orderDataService
			.getAddOn(this.id, this.quotationId, this.partnerCode)
			.subscribe({
				next: (x) => {
					this.ngxSpinnerService.hide();
					this.addOnList = x;
					if (this.addOnList) {
						this.sortDriversAddonSequence();
					}
					this.addOnOptionalCategory = [
						...new Set(
							this.addOnList.filter((y) => !y.included).map((z) => z.category)
						)
					];
					this.addOnList.forEach((y: any) => {
						if (y.category == "Windshield") {
							this.windshieldMin = this.getMinMaxWindscreenPrice(y, "min");
							this.windshieldMax = this.getMinMaxWindscreenPrice(y, "max");

							this.addOnFrmGroup.controls.windshield.setValue(
								this.windshieldMin || 500
							);
						}

						if (y.code == "AdditionalDrivers") {
							this.maxAdditionalDriver = this.getRule(y)?.max ?? null;
						}

						if (y.code == "FGAP") {
							this.fgapPriceList = eval(y.evaluate);
							if (this.fgapPriceList)
								this.addOnFrmGroup.controls.fgap.setValue(
									this.fgapPriceList[0]
								);
						}

						if (y.category == "CART") {
							this.selectedCartDays = this.cartDayList[0].codeValue;
							this.selectedCartDailyCoverage =
								this.cartDailyCoverageList[0].codeValue;
							this.addOnFrmGroup.controls.cartDays.setValue(
								this.selectedCartDays
							);
							this.addOnFrmGroup.controls.cartDailyCoverage.setValue(
								this.selectedCartDailyCoverage
							);
						}

						if (y.category == "GCKT") {
							this.minGCKTCoverage = this.getRule(y)?.min ?? null;
							this.addOnFrmGroup.controls.gckt.setValue(this.minGCKTCoverage);
						}

						if (y.category == "VA") {
							this.minVACoverage = this.getRule(y)?.min ?? null;
							this.addOnFrmGroup.controls.va.setValue(this.minVACoverage);
						}

						if (y.code == "EHailing") {
							this.isDailyAnnualOrAnnual();
							if (this.dailyAndAnnual)
								y.code = "AnnualEHailing"
						}

						if (y.included) {
							this.includeAddOnList.push(y);
							this.selectedAddOn.push(y);
						}

						if (!this.isPAPlanGeneraliMotorcycleChecked && y.category == 'UnlimitedTowing_Motorcycle') {
							this.UnlimitedTowing_Motorcycle = this.includeAddOnList.find(
								(x) => x.category == "UnlimitedTowing_Motorcycle"
							);
							this.includeAddOnList = this.includeAddOnList.filter(
								(x) => x.category !== "UnlimitedTowing_Motorcycle"
							);
							this.selectedAddOn = this.selectedAddOn.filter(
								(x) => x.category !== "UnlimitedTowing_Motorcycle"
							);
						}
					});
				},
				error: (e) => {
					this.ngxSpinnerService.hide();
					window.location.href = "/";
					this.alertService.openSnackBar(`Error: ${e.toString()}`);
				}
			});
	}

	isDailyAnnualOrAnnual(): void {
		const { dealerType, eHailingUsed } = this.requestData;

		const ehailingMap = {
			POLICYSTREET: {
				true: {
					daily_annual: ["Allianz", "AXA", "Zurich_Takaful"],
					daily: ["Chubb", "TMIM"]
				},
				false: {
					daily_annual: ["Zurich_Takaful"],
					daily: ["Chubb"]
				}
			},
			CARSOMEDR: {
				true: {
					daily_annual: ["Allianz", "AXA"],
					daily: ["Chubb"]
				},
				false: {
					daily_annual: ["AXA", "Zurich_Takaful"],
					daily: ["Chubb", "TMIM"]
				}
			}
		};

		const config = ehailingMap[dealerType]?.[eHailingUsed];

		if (config?.daily_annual.includes(this.selectedQuotation.code) || config?.daily.includes(this.selectedQuotation.code))
			this.dailyAndAnnual = true;
		else
			this.dailyAndAnnual = false;
	}

	sortDriversAddonSequence() {
		// Define the custom order for specific codes
		const order = ["UnlimitedDrivers", "AdditionalDrivers"];

		this.addOnList.sort((a, b) => {
			// Handle custom sorting logic
			const indexA = order.indexOf(a.code);
			const indexB = order.indexOf(b.code);

			if (indexA > -1 && indexB > -1) {
				return indexA - indexB; // Both are in the order list
			} else if (indexA > -1) {
				return -1; // a should come before b
			} else if (indexB > -1) {
				return 1; // b should come before a
			} else {
				return 0; // Default sorting for other items
			}
		});
	}

	fgapAddOnsChanged(index: string) {
		this.fgapAddOnsIndex = index;
	}

	step2DisableBtnCondition() {
		if (this.addOnFrmGroup.valid) {
			return false;
		}
		return true;
	}

	private getProductDocument() {
		if (!this.selectedQuotation) return;
		this.productDocumentInterface = [];
		let frmArray = this.getAgreeFormArray();
		frmArray.clear();
		this.orderDataService
			.getProductDocumentById(
				this.selectedQuotation.productId,
				this.translate.currentLang,
				this.requestData.insuranceType
			)
			.subscribe({
				next: (x) => {
					this.productDocumentInterface = x;
					x.forEach((doc) => {
						if (doc.neededUserAgree) {
							let frm = this.formBuilder.group({
								checked: new UntypedFormControl(false, [
									Validators.requiredTrue
								]),
								name: new UntypedFormControl(doc.name),
								url: new UntypedFormControl(doc.url)
							});
							frmArray.push(frm);
						}
					});
				},
				error: (e) => {
					window.location.href = "/";
					this.alertService.openSnackBar(`Error: ${e.toString()}`);
				}
			});
	}

	private async checkIfQuotationExpired(): Promise<boolean> {
		let quotation: any[];

		try {
			quotation = await this.orderDataService
				.getQuotationById(this.id, this.partnerCode)
				.toPromise();

			if (quotation.hasOwnProperty("expiredDetails")) {
				this.alertService.openSnackBar("Quotation has expired");
			} else {
				this.quotationList = quotation;

				const hasNewQuotation = this.quotationList.some(
					(item) => item.status === "New"
				);

				if (hasNewQuotation) {
					// Start or restart the timer if needed
					this.timerService.startTimer();

					// Ensure only one subscription to the timerExpired$ observable
					if (!this.timerSubscription) {
						this.timerSubscription = this.timerService.timerExpired$
							.pipe(takeUntil(this.timerUnsubscribe$))
							.subscribe(() => {
								// Call the function again after timer expires
								this.checkIfQuotationExpired();
							});
					}
				} else {
					// Stop the timer and clean up subscription if no new quotations
					this.timerService.stopTimer();
					if (this.timerSubscription) {
						this.timerSubscription.unsubscribe();
						this.timerSubscription = null;
					}
				}
				return false;
			}
		} catch (err) {
			window.location.href = "/";
			return false;
		}

		return true;
	}

	public async updateQuotationMethod(isConnected: boolean) {
		// Get new updated quotation main method using signalr
		// If connection fail, only call the fallback method (refresh page every 5mins)
		if (isConnected) {
			this.signalRService.receiveUpdatedQuotation().subscribe((message) => {
				this.updateQuotationPrice(message);
			});
		} else {
			await this.checkIfQuotationExpired();
		}
	}

	updateQuotationPrice(insurerName: string) {
		let quotation: any[];
		this.orderDataService
			.getQuotationById(this.id, this.partnerCode)
			.subscribe((x) => {
				quotation = x;
				this.quotationList = quotation;
				this.quotationListAvailable = quotation.filter(
					(q) => q.status === "Available"
				);
				this.cd.detectChanges();
        var  currentDateTime: Date = new Date(); 
     		 console.log("[" +  currentDateTime + "]" + insurerName + " display should be updated");

				// Stop signalr connection if all quotations are updated
				if (this.isAllQuotationUpdated()) {
					this.signalRService.stopConnection();
				}
			});
	}

	isAllQuotationUpdated(): boolean {
		if (
			this.quotationList.filter(
				(x) => x.status == "New" || x.status == "On-Hold"
			).length == 0
		)
			return true;
		else return false;
	}

	applySavedDraftOrder() {
		// Issues:
		//	- need to ensure Country Code for Mobile Number is handled in Step 3

		// Retrieve Saved Draft (if any)
		this.orderDataService.getOrderByLinkId(this.id).subscribe({
			next: (x: any) => {
				if (x.order != null) {
					this.isApplyDraft = true;
					let savedOrder = x.order;
					let savedAddDriver = x.addDriver;
					let savedDocuments = x.document;

					// Populate Step 2 (Add Ons)
					const savedAddOns: ProductAddOnInterface[] = x.addOn.map((x) => ({
						category: x.category,
						code: x.code,
						condition: x.condition,
						evaluate: x.evaluate,
						isConditionFirst: x.isConditionFirst,
						rules: x.rules,
						customCode: x.customCode,
						id: x.motorAddOnId,
						included: x.included,
						hidePriceBreakdown: x.hidePriceBreakdown,
						isIncludeSST: x.isIncludeSST
					}));

					this.selectedAddOn = savedAddOns;

					this.selectedAddOn.forEach((a) => {
						let val = undefined;

						if (a.category !== "PSXTRA" && !a.isIncludeSST) {
							this.selectedNonSSTAddOnToDisplay.push(a);
						}

						if (a.category == "Windshield") {
							val = x.addOn.find((y) => y.category == a.category).value;
							this.addOnFrmGroup.controls.windshield.setValidators([
								Validators.min(this.windshieldMin),
								Validators.max(this.windshieldMax),
								Validators.required
							]);
							this.addOnFrmGroup.controls.windshield.setValue(val);
							this.addOnFrmGroup.controls.windshield.updateValueAndValidity();
							a.value = this.getPrice(a, val);
						}

						if (a.category == "LLTP") {
							this.addOnFrmGroup.controls.lltpSeats.setValue(savedOrder.seat);
						}

						if (a.category == "CART") {
							val = x.addOn.find((y) => y.category == a.category).customValue;
							let customVal = this.getCustomValue(val);
							this.addOnFrmGroup.controls.cartDays.setValue(
								customVal.cartDays.toString()
							);
							this.addOnFrmGroup.controls.cartDailyCoverage.setValue(
								customVal.cartDailyCoverage.toString()
							);
						}

						if (a.category == "GCKT") {
							val = x.addOn.find((y) => y.category == a.category).value;
							this.addOnFrmGroup.controls.gckt.setValue(val);
						}

						if (a.category == "VA") {
							val = x.addOn.find((y) => y.category == a.category).value;
							this.addOnFrmGroup.controls.va.setValue(val);
						}
					});

					//	Road Tax
					this.addOnFrmGroup.controls.isIncludeRoadtax.setValue(
						savedOrder.includeRoadTax
					);
					this.addOnFrmGroup.controls.isNotBlacklisted.setValue(
						savedOrder.includeRoadTax
					);
					this.isIncludeDigitalRoadtax = savedOrder.includeDigitalRoadTax;

					// WindShield
					this.addOnFrmGroup.controls.isWindshieldExceeded.setValue(
						savedOrder.includeWindshield
					);

					//	Additional Drivers
					if (
						savedAddOns.some((x) => x.code == "AdditionalDrivers") &&
						savedAddDriver.length > 0
					) {
						this.isDriverChecked = true;

						savedAddDriver.forEach((d) => {
							this.addDriver(d);
						});
					}

					// Populate Step 3: Personal details
					this.infoFrmGroup.controls.name.setValue(savedOrder.name);
					this.infoFrmGroup.controls.occupation.setValue(savedOrder.occupation);
					this.infoFrmGroup.controls.mobileNo.setValue(savedOrder.mobileNo);
					this.infoFrmGroup.controls.email.setValue(savedOrder.email);
					this.infoFrmGroup.controls.address.setValue(savedOrder.address1);
					this.infoFrmGroup.controls.address2.setValue(savedOrder.address2);
					this.infoFrmGroup.controls.city.setValue(savedOrder.city);
					this.infoFrmGroup.controls.state.setValue(savedOrder.state);

					// Populate Step 3: Delivery Address
					this.infoFrmGroup.controls.deliveryAddress.setValue(
						savedOrder.deliveryAddress1
					);
					this.infoFrmGroup.controls.deliveryAddress2.setValue(
						savedOrder.deliveryAddress2
					);
					this.infoFrmGroup.controls.deliveryCity.setValue(
						savedOrder.deliveryCity
					);
					this.infoFrmGroup.controls.deliveryPostcode.setValue(
						savedOrder.deliveryPostcode
					);
					this.infoFrmGroup.controls.deliveryState.setValue(
						savedOrder.deliveryState
					);
					this.isSameAddressCheck = this.isSameAddressChecked();

					// Populate Step 3: Financing details
					this.infoFrmGroup.controls.financingType.setValue(
						savedOrder.financeType
					);
					this.infoFrmGroup.controls.bank.setValue(savedOrder.hirePurchase);
					this.infoFrmGroup.controls.effectiveDate.setValue(
						new Date(savedOrder.hirePurchaseEffectiveDate)
					);

					// Populate Step 3: Upload
					if (savedDocuments.length > 0) {
						savedDocuments.forEach((doc) => {
							const blob = FileFunction.base64ToBlob(
								doc.result.base64,
								doc.result.contentType
							);
							const file = new File([blob], doc.result.fileName, {
								type: doc.result.contentType
							});

							if (doc.result.refType == "ID") this.mykadOrPassport.push(file);
							else if (doc.result.refType == "LOU")
								this.letterOfUndertaking.push(file);
							else if (doc.result.refType == "VehiclePhoto")
								this.vehiclePhoto.push(file);
							else if (doc.result.refType == "VehicleInteriorPhoto")
								this.vehicleInteriorPhoto.push(file);
							else if (doc.result.refType == "VehicleVideo")
								this.vehicleVideo.push(file);
						});
					}

					// Populate Step 4 (Payment Info)
					const paymentData: IPaymentData = {
						bank: null,
						ewalletType: null,
						fpxEnterpriseType: null,
						installmentMonth: null,
						paymentChannel: null,
						paymentProvider: null,
						paymentType: null,
						eppRate: null,
						paymentOptionType: null,
						formIsValid: true
					};

					if (savedOrder.paymentType == PAYMENT_OPTION_FP) {
						// Full Price Payment
						paymentData.bank = null;
						paymentData.eppRate = 0;
						paymentData.installmentMonth = null;
						paymentData.paymentType = savedOrder.paymentType;

						if (savedOrder.paymentProvider == PAYMENT_OPTION_RAZER) {
							paymentData.paymentProvider = savedOrder.paymentProvider;
							paymentData.paymentOptionType = savedOrder.paymentType;

							// Payment Channel: Credit
							if (savedOrder.paymentChannel == "credit" || savedOrder.paymentChannel == "fpx") {
								paymentData.paymentChannel = savedOrder.paymentChannel;
								paymentData.ewalletType = "";
								paymentData.fpxEnterpriseType = "";
							}
							else {
								// Payment Channel: FPXEnterprise
								if (savedOrder.paymentChannel.startsWith('FPX_')) {
									paymentData.paymentChannel = PAYMENT_OPTION_FPX_ENTERPRISE;
									paymentData.ewalletType = "";
									paymentData.fpxEnterpriseType = savedOrder.paymentChannel;
								}

								// Payment Channel: EWallet
								else {
									paymentData.paymentChannel = PAYMENT_OPTION_EWALLET;
									paymentData.ewalletType = savedOrder.paymentChannel;
									paymentData.fpxEnterpriseType = "";
								}
							}
						} else if (savedOrder.paymentProvider == PAYMENT_OPTION_SHOPBACK) {
							paymentData.ewalletType = null;
							paymentData.paymentChannel = PAYMENT_OPTION_SHOPBACK;
							paymentData.paymentOptionType = savedOrder.paymentProvider;
							paymentData.paymentProvider = PAYMENT_OPTION_SHOPBACK;
						}
					} else if (savedOrder.paymentType == PAYMENT_OPTION_EPP) {
						// EPP Payment
						paymentData.bank = savedOrder.paymentChannel;
						paymentData.eppRate = savedOrder.eppRate;
						paymentData.ewalletType = null;
						paymentData.installmentMonth = savedOrder.installmentMonth;
						paymentData.paymentType = PAYMENT_OPTION_EPP;

						if (savedOrder.paymentProvider == PAYMENT_OPTION_RAZER) {
							paymentData.paymentChannel = savedOrder.channel;
							paymentData.paymentOptionType = PAYMENT_OPTION_EPP_3_6_12_MONTHS;
							paymentData.paymentProvider = PAYMENT_OPTION_RAZER;
						} else if (savedOrder.paymentProvider == PAYMENT_OPTION_PAYEX) {
							paymentData.paymentChannel = savedOrder.paymentChannel;
							paymentData.paymentOptionType = PAYMENT_OPTION_EPP_6_12_MONTHS;
							paymentData.paymentProvider = PAYMENT_OPTION_PAYEX;
						}
					}

					this.paymentData = paymentData;

					// Populate Promo Code
					if (savedOrder.promoCode != null) {
						this.promoCode = savedOrder.promoCode;
						this.applyPromoCode();
					}
				}
			},
			error: () => {
				this.ngxSpinnerService.hide();
			}
		});
	}

	private promoCheck() {
		if (!this.promo) return;
		if (
			this.promo.customCode == "RoadTaxDelivery" &&
			!this.addOnFrmGroup.value.isIncludeRoadtax
		) {
			this.promo = null;
			this.promoError = "InvalidPromoCode";
		}
	}

	get hideStepperLabel() {
		return this.stepper?.selectedIndex === 0 ? "hide-stepper" : "";
	}

	get sortedQuotationList() {
		return this.quotationList.sort((a, b) => {
			if (a.status === "New" && b.status !== "New") {
				return -1; // "New" always on top
			}
			if (a.status !== "New" && b.status === "New") {
				return 1; // Place "New" above others
			}
			if (a.status === "Rejected" && b.status !== "Rejected") {
				return -1; // "Rejected" comes after "New" but before others
			}
			if (a.status !== "Rejected" && b.status === "Rejected") {
				return 1; // Place "Rejected" below "New"
			}
			return 0;
		});
	}

	onStepChange(e: StepperSelectionEvent) {
		this.paymentFrmGroup.controls.payment.setValue(e.selectedIndex == 4);
		if (e.selectedIndex == 3) {
			let value = this.infoFrmGroup.getRawValue();
			if (
				this.addOnFrmGroup.value?.isIncludeRoadtax &&
				this.isSameAddressCheck
			) {
				this.infoFrmGroup.controls.deliveryAddress.setValue(value.address);
				this.infoFrmGroup.controls.deliveryAddress2.setValue(value.address2);
				this.infoFrmGroup.controls.deliveryCity.setValue(value.city);
				this.infoFrmGroup.controls.deliveryPostcode.setValue(value.postcode);
				this.infoFrmGroup.controls.deliveryState.setValue(value.state);
			} else if (!this.addOnFrmGroup.value?.isIncludeRoadtax) {
				this.infoFrmGroup.controls.deliveryAddress.reset();
				this.infoFrmGroup.controls.deliveryAddress2.reset();
				this.infoFrmGroup.controls.deliveryCity.reset();
				this.infoFrmGroup.controls.deliveryPostcode.reset();
				this.infoFrmGroup.controls.deliveryState.reset();

				this.infoFrmGroup.controls.deliveryAddress.setValidators([]);
				this.infoFrmGroup.controls.deliveryAddress2.setValidators([]);
				this.infoFrmGroup.controls.deliveryCity.setValidators([]);
				this.infoFrmGroup.controls.deliveryPostcode.setValidators([]);
				this.infoFrmGroup.controls.deliveryState.setValidators([]);

				this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();
				this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
			}
		}
		if (e.selectedIndex == 1 || e.selectedIndex == 2) {
			this.applyPromoCode();
			this.isStep2Valid = true;
		}

		if (e.selectedIndex == 2) this.getListDropdowns();

		// Recalculate premiums when customer navigate from Add On page to Personal Details page
		//  - applied for: Chubb
		if ((this.isGeneraliIQ || this.isChubbIQ) && e.previouslySelectedIndex == 1)
			this.recalculateInstantQuotationPricing();
	}

	recalculateInstantQuotationPricing() {
		// Recalculate premiums is required for IQ due to addons (extra coverages)
		//  - when user selected 1 or more addons, the premiums for the addons will be retrieved from API
		//  - this function mainly reset the 'evaluate' with premiums calculated from API for the addons
		if (this.selectedAddOn && this.selectedAddOn.length > 0) {
			this.ngxSpinnerService.show();

			if (this.isGeneraliIQ) {
				this.orderDataService
					.getGeneraliQuotationPricing(
						this.selectedQuotation.id,
						this.selectedAddOn,
						this.addOnFrmGroup.value.drivers,
						this.addOnFrmGroup.value.windshield,
						this.addOnFrmGroup.value.gckt,
						this.addOnFrmGroup.value.cartDays,
						this.addOnFrmGroup.value.cartDailyCoverage
					)
					.subscribe({
						next: (x) => {
							this.selectedAddOn = x as any[];
							this.ngxSpinnerService.hide();
						},
						error: (err) => {
							this.alertService.openSnackBar(
								"Premium calculation failed, please contact Policy Street."
							);
							this.ngxSpinnerService.hide();
							this.stepper.selectedIndex = 1;
						}
					});
			}

			if (this.isChubbIQ) {
				this.orderDataService
					.getChubbQuotationPricing(
						this.selectedQuotation.id,
						this.selectedAddOn,
						this.addOnFrmGroup.value.windshield
					)
					.subscribe({
						next: (x) => {
							this.selectedAddOn = x as any[];
							this.ngxSpinnerService.hide();
						},
						error: (err) => {
							this.alertService.openSnackBar(
								"Premium calculation failed, please contact Policy Street."
							);
							this.ngxSpinnerService.hide();
							this.stepper.selectedIndex = 1;
						}
					});
			}
		}
	}

	applyPromoCode() {
		if (!this.promoCode) return;
		this.ngxSpinnerService.show();
		this.promoError = null;
		this.promo = null;
		this.orderDataService
			.applyPromoCode(
				this.id,
				this.promoCode,
				this.getPaymentValues().totalCharge,
				this.dealerRepId
			)
			.subscribe({
				next: (x) => {
					this.promo = x;
					this.ngxSpinnerService.hide();
					this.promoCheck();

					if (
						this.promo &&
						this.paymentData?.paymentType === PAYMENT_OPTION_EPP
					) {
						this.paymentOption
							.setEppBanksList(this.promo?.id)
							.then(() => {
								this.paymentOption.refreshEppPaymentOption();
							})
							.catch((error) => {
								console.error("Error setting EPP Banks list:", error);
							});
					}
				},
				error: (err) => {
					this.ngxSpinnerService.hide();
					this.promoError = err.error.message;

          if (err.error.message === "InsufficientPromoCodeMinAmount"){
            this.promoMinAmount = Number(err.error.parameters[0]);
          }

          if (err.error.message === "InsufficientPromoCodeMaxAmount"){
            this.promoMaxAmount = Number(err.error.parameters[0]);
          }
				}
			});
	}

	clearPromoCode() {
		this.promoCode = null;
		this.promoError = null;
		this.promo = null;

		if (this.paymentData?.paymentType === PAYMENT_OPTION_EPP) {
			this.paymentOption
				.setEppBanksList("00000000-0000-0000-0000-000000000000")
				.then(() => {
					this.paymentOption.refreshEppPaymentOption();
				})
				.catch((error) => {
					console.error("Error setting EPP Banks list:", error);
				});
		}
	}

	getFormArray() {
		return this.addOnFrmGroup.get("drivers") as UntypedFormArray;
	}

	getAgreeFormArray() {
		return this.agreementFrmGroup.get("doc") as UntypedFormArray;
	}

	addDriver(data?: any) {
		let frmArray = this.getFormArray();
		let form = this.formBuilder.group({
			name: [null, Validators.required],
			idType: [this.idTypeList[0].codeValue, Validators.required],
			identityNo: [
				null,
				[Validators.required, ValidatorFunction.nricValidator()]
			],
			dob: [null, Validators.required],
			gender: ["M", Validators.required],
			maritalStatus: ["Single", Validators.required],
			relationship: [null, Validators.required],
			isMalaysian: [true]
		});

		if (data != undefined) {
			form.patchValue(data);
		}

		form.get("idType").valueChanges.subscribe((value) => {
			if (value === "IC_NO") {
				form
					.get("identityNo")
					.setValidators([
						Validators.required,
						ValidatorFunction.nricValidator()
					]);
			} else {
				form.get("identityNo").setValidators(Validators.required);
			}

			if (["IC_NO", "POLICE/ARMY"].includes(value)) {
				form.get("isMalaysian").patchValue(true);
			} else {
				form.get("isMalaysian").patchValue(false);
			}

			form.get("identityNo").reset();
			form.get("identityNo").updateValueAndValidity();
		});

		form.get("identityNo").valueChanges.subscribe((value) => {
			if (
				form.get("identityNo").invalid &&
				form.get("idType").value === "IC_NO"
			) {
				form.get("dob").reset();
			}

			if (
				form.get("identityNo").valid &&
				form.get("idType").value === "IC_NO"
			) {
				let date = moment(value.substring(0, 6), "YYMMDD");
				let lastChar = value.substring(11);
				let gender = lastChar % 2 ? "M" : "F";

				if (moment().isBefore(date)) {
					date.subtract(100, "year");
				}
				form.patchValue({
					dob: date.toDate(),
					gender: gender
				});
			}
		});

		frmArray.push(form);
	}

	deleteDriver(i: number) {
		let frmArray = this.getFormArray();
		frmArray.removeAt(i);
	}

	selectQuotation(id: string) {
		let lastQuotationId = this.quotationId;
		this.quotationFrmGroup.controls.id.setValue(id);
		this.quotationId = id;
		this.selectedQuotation = this.quotationList.find((x) => x.id == id);

		this.isAllianzQuotation = this.selectedQuotation.code == "Allianz"

		/** For Motorcycle only: Duplicate insurer, based on [A2C-477] requirements, 
				TP & COM shows at the same time based on vehicle age **/
		if (this.requestData.vehicleType == "Motorcycle") {
			if (this.selectedQuotation.requestType == "MotorcycleTPRequest")
				this.requestData.insuranceType = "TP"
			else
				this.requestData.insuranceType = "COM"
		}


		this.router.navigate([], {
			queryParams: {
				id: id
			}
		});
		if (this.addOnList.length == 0) {
			this.getAddOn();
		} else if (lastQuotationId != this.quotationId) {
			this.addOnList = [];
			this.initAddOnForm();
			this.getAddOn();
			this.selectedAddOn = [];
			this.isDriverChecked = false;
			this.isFloodChecked = false;
			this.isVBETChecked = false;
		}
		this.getProductDocument();
		this.stepper.next();

		// Apply saved draft to forms if exist
		this.applySavedDraftOrder();

		this.isGeneraliIQ =
			this.selectedQuotation.name == "Generali" &&
			this.selectedQuotation.isInstantQuotation;
		this.isChubbIQ =
			this.selectedQuotation.name == "Chubb" &&
			this.selectedQuotation.isInstantQuotation;
	}

	editQuotation() {
		let dialogRef = this.dialog.open(EditQuotationsNewComponent, {
			data: {
				id: this.id,
				request: this.requestData,
				quotationList: this.quotationList
			},
			panelClass: "edit-quote-dialog-2",
			maxWidth: "500px"
		});

		dialogRef.afterClosed().subscribe((x) => {
			if (x) {
				let successDialog = this.dialog.open(SubmitSuccessDialogComponent, {
					data: { email: this.requestData.email, redirect: "/transactions" },
					panelClass: "success-dialog",
					maxWidth: "500px"
				});
			}
		});
	}

	carDetails() {
		let dialogRef = this.dialog.open(CarDetailsDialogComponent, {
			data: this.requestData
		});

		dialogRef.afterClosed().subscribe((x) => {});
	}

	carPlan() {
		let dialogRef = this.dialog.open(CarPlanDialogComponent, {
			data: this.requestData
		});

		dialogRef.afterClosed().subscribe((x) => {});
	}

	getAddOnListByCategory(val: string) {
		return this.addOnList.filter((x) => x.category == val);
	}

	isAddOnSelected(item: ProductAddOnInterface) {
		return this.selectedAddOn.some((x) => x.id == item.id);
	}

	getPrice(item: ProductAddOnInterface, val?: any) {
		return getAddOnPrice(
			item,
			val,
			this.selectedCartDays,
			this.selectedCartDailyCoverage,
			this.cartAddOnPriceList,
			this.selectedAddOn
		);
	}

	toggleUnlimitedTowingPlan(display: string) {
		const elements = document.getElementsByClassName("UnlimitedTowing");
		for (let i = 0; i < elements.length; i++) {
			(elements[i] as HTMLElement).style.display = display;
		}
		this.clearPromoCode();
	}

	toggleAddOn(e: MatCheckboxChange) {
		let value: ProductAddOnInterface = e.source.value as any;

		if (e.checked) {
			if (
				value.code === "MPAPlus" ||
				value.code === "BISP" ||
				value.code === "MERW"
			) {
				this.toggleUnlimitedTowingPlan("none");
				this.selectedAddOn = this.selectedAddOn.filter(
					(x) => x.category !== "UnlimitedTowing"
				);
			}
			if (value.category === "LLTP") {
				this.addOnFrmGroup.controls.lltpSeats.setValue(this.numberOfLltpSeats);
			}
			this.selectedAddOn.push(value);

			if (value.category !== "PSXTRA" && !value.isIncludeSST) {
				this.selectedNonSSTAddOnToDisplay.push(value);
			}
			if (value.code === "PAPlanGeneraliMotorcycle" && value.customCode == "IMOTORBIKE") {
				this.isPAPlanGeneraliMotorcycleChecked = true;
				this.includeAddOnList.push(this.UnlimitedTowing_Motorcycle);
				this.selectedAddOn.push(this.UnlimitedTowing_Motorcycle);
			}

		} else {
			if (
				value.code === "MPAPlus" ||
				value.code === "BISP" ||
				value.code === "MERW"
			) {
				this.toggleUnlimitedTowingPlan("flex");
			}
			let index = this.selectedAddOn.findIndex((x) => x.id == value.id);
			if (index >= 0) {
				this.selectedAddOn.splice(index, 1);
			}

			let nonSSTIndex = this.selectedNonSSTAddOnToDisplay.findIndex(
				(x) => x.id == value.id
			);
			if (nonSSTIndex >= 0) {
				this.selectedNonSSTAddOnToDisplay.splice(nonSSTIndex, 1);
			}

			if (value.category === "CART") {
				this.selectedCartDays = this.cartDayList[0].codeValue;
				this.selectedCartDailyCoverage =
					this.cartDailyCoverageList[0].codeValue;
				this.addOnFrmGroup.controls.cartDays.setValue(this.selectedCartDays);
				this.addOnFrmGroup.controls.cartDailyCoverage.setValue(
					this.selectedCartDailyCoverage
				);
			}
			if (value.category === "GCKT") {
				this.addOnFrmGroup.controls.gckt.setValue(this.minGCKTCoverage);
			}
			if (value.category === "VA") {
				this.addOnFrmGroup.controls.va.setValue(this.minVACoverage);
			}
			if (value.code === "PAPlanGeneraliMotorcycle" && value.customCode == "IMOTORBIKE") {
				this.isPAPlanGeneraliMotorcycleChecked = false;
				this.includeAddOnList = this.includeAddOnList.filter(
					(x) => x.category !== "UnlimitedTowing_Motorcycle"
				);
				this.selectedAddOn = this.selectedAddOn.filter(
					(x) => x.category !== "UnlimitedTowing_Motorcycle"
				);
			}
		}
		if (value.category == "Drivers") {
			let frmArray = this.getFormArray();
			frmArray.reset();
			frmArray.clear();
			if (e.checked && value.code == "AdditionalDrivers") this.addDriver();
		}
		if (value.category == "Windshield") {
			if (e.checked) {
				this.addOnFrmGroup.controls.windshield.setValidators([
					Validators.min(this.windshieldMin),
					Validators.max(this.windshieldMax),
					Validators.required
				]);
				// PSSR-1361: set isWindshieldExceeded to required once Windshield is checked, only for Zurich & Zurich_Takaful
				if (
					(this.selectedQuotation.code == "Zurich" ||
						this.selectedQuotation.code == "Zurich_Takaful") &&
					!this.requestData.isCompany
				) {
					this.addOnFrmGroup.controls.isWindshieldExceeded.setValidators([
						Validators.requiredTrue
					]);
				}
			} else {
				this.addOnFrmGroup.controls.windshield.clearValidators();
				// PSSR-1361: set isWindshieldExceeded to non-required once Windshield is unchecked, only for Zurich & Zurich_Takaful
				if (
					(this.selectedQuotation.code == "Zurich" ||
						this.selectedQuotation.code == "Zurich_Takaful") &&
					!this.requestData.isCompany
				) {
					this.addOnFrmGroup.controls.isWindshieldExceeded.clearValidators();
				}
			}
			this.addOnFrmGroup.controls.windshield.updateValueAndValidity();
			this.addOnFrmGroup.controls.isWindshieldExceeded.updateValueAndValidity();
		}
		this.clearPromoCode();
	}

	getListDropdowns() {
		this.orderDataService.getHirePurchaseList().subscribe((x) => {
			this.hirePurchaseList = x;
			this.filteredHirePurchase =
				this.infoFrmGroup.controls.bank.valueChanges.pipe(
					startWith(""),
					map((value) =>
						this.filterAutocompleteList(value || "", this.hirePurchaseList)
					)
				);
		});

		this.filteredDealerOutletsList =
			this.infoFrmGroup.controls.dealerOutlets.valueChanges.pipe(
				startWith(""),
				map((value) =>
					this.filterAutocompleteList(value || "", this.dealerOutletsList)
				)
			);
	}

	radioChange(e: ProductAddOnInterface, isCheckbox: boolean = false) {
		let index = this.selectedAddOn.findIndex((x) => x.category == e.category);
		if (index >= 0) this.selectedAddOn.splice(index, 1);
		if (!isCheckbox || index == -1) {
			this.selectedAddOn.push(e);
		}

		let frmArray = this.getFormArray();
		if (frmArray.length == 0 && e.code == "AdditionalDrivers") this.addDriver();
		else {
			frmArray.reset();
			frmArray.clear();
		}
	}

	getRule(e: ProductAddOnInterface) {
		if (e.rules) {
			return JSON.parse(e.rules);
		}
		return null;
	}

	getCustomValue(val: string) {
		if (val) {
			return JSON.parse(val);
		}
		return null;
	}

	hasSelectedCode(val: string) {
		if (this.isVehicleTypeMotorcycle && val == 'PAPlanGeneraliMotorcycle') {

		}

		return this.selectedAddOn.some((x) => x.code == val);
	}

	hasSelectedCategory(val: string) {
		return this.selectedAddOn.some((x) => x.category == val);
	}

	toggleRoadTax(e: MatCheckboxChange) {
		if (e.checked) {
			this.showRoadTaxList = true;
			this.isIncludeDigitalRoadtax = true;
		}

		if (
			!this.requestData.isMalaysian ||
			this.requestData.isCompany ||
			!e.checked
		) {
			this.showRoadTaxList = false;
			this.isIncludeDigitalRoadtax = false;
			this.addOnFrmGroup.controls.roadTaxPrice.setValue(
				this.requestData.roadTaxPrice
			);
		}
		this.clearPromoCode();
	}

	isRoadTaxSelected(item: any) {
		if (item) {
			return (this.showRoadTaxList = true);
		}
		return (this.showRoadTaxList = false);
	}

	radioDigitalRoadTaxChange(e: any) {
		if (e.value == undefined) {
			this.isIncludeDigitalRoadtax = true;
			this.addOnFrmGroup.controls.roadTaxPrice.setValue(
				this.requestData.roadTaxPrice
			);
		} else {
			this.isIncludeDigitalRoadtax = false;
			this.addOnFrmGroup.controls.roadTaxPrice.setValue(
				this.requestData.roadTaxPrice + 15
			);
		}
	}

	getTotal() {
		const paymentValues = this.getPaymentValues();

		if (this.paymentData?.paymentType === PAYMENT_OPTION_SHOPBACK) {
			return Math.max(paymentValues.shopbackTotalAmount, 0);
		}

		if (this.paymentData?.paymentType === PAYMENT_OPTION_EPP) {
			return Math.max(paymentValues.bankInstallmentTotalAmount, 0);
		}

		if (this.isVehicleTypeMotorcycle && paymentValues.totalAmount != paymentValues.totalCharge)
			return Math.max(paymentValues.totalAmount - 1, 0);

		return Math.max(paymentValues.totalAmount, 0);
	}

	getPaymentValues() {
		// Extract the BNPL Charge rate for payment calculation
		let paymentProvider = this.paymentData?.paymentProvider;
		const bnplRate = this.bnplRateList?.filter(
			(entry) => entry.paymentMethod == paymentProvider
		);
		let bnplIsSubsidized = false;
		let bnplTotalServiceTaxRate = 0;
		if (bnplRate.length > 0) {
			bnplTotalServiceTaxRate = bnplRate[0].totalServiceTaxRate;
			bnplIsSubsidized = bnplRate[0].isSubsidized;
		}

		const paymentValues: IPaymentValues = getPaymentValues(
			this.addOnFrmGroup.value?.isIncludeRoadtax,
			this.isIncludeDigitalRoadtax,
			this.requestData,
			this.selectedQuotation,
			this.promo,
			this.addOnFrmGroup,
			this.selectedAddOn,
			this.paymentData.eppRate,
			this.paymentData?.paymentChannel,
			bnplTotalServiceTaxRate,
			bnplIsSubsidized,
			this.cartAddOnPriceList,
			this.numberOfLltpSeats
		);

		return paymentValues;
	}

	updatePaymentType(data: IPaymentData) {
		this.paymentData = data;
	}

	getInstallmentDetails() {
		const { installmentMonth, paymentType } = this.paymentData;

		if (paymentType === PAYMENT_OPTION_SHOPBACK) {
			const { shopbackTotalAmount } = this.getPaymentValues();
			return {
				installmentMonths: this.getPaymentMonthLabel(3),
				installmentAmount: shopbackTotalAmount / installmentMonth
			};
		}

		if (paymentType === PAYMENT_OPTION_EPP && installmentMonth) {
			const { bankInstallmentTotalAmount } = this.getPaymentValues();

			return {
				installmentMonths: this.getPaymentMonthLabel(installmentMonth),
				installmentAmount: bankInstallmentTotalAmount / installmentMonth
			};
		}

		return null;
	}

	getIdentityNoLabel() {
		if (this.requestData?.isMalaysian && !this.requestData?.isCompany)
			return "common.icNo";
		else if (!this.requestData?.isMalaysian) return "common.passport";
		return "common.businessRegistrationNo";
	}

	getNameLabel() {
		if (this.requestData?.isMalaysian && !this.requestData?.isCompany)
			return this.isVehicleTypeMotorcycle ? "common.namePerIcMotorcycle" : "common.namePerIc";
		else if (!this.requestData?.isMalaysian) return "common.namePerPassport";
		return "common.companyName";
	}

	getPaymentMonthLabel(numberOfMonths: number) {
		if (numberOfMonths == 3) return "paymentOptions.for3months";
		if (numberOfMonths == 6) return "paymentOptions.for6months";
		if (numberOfMonths == 12) return "paymentOptions.for12months";

		return "";
	}

	isAddressValid() {
		return !(
			this.infoFrmGroup.controls.address.invalid ||
			this.infoFrmGroup.controls.address2.invalid ||
			this.infoFrmGroup.controls.city.invalid ||
			this.infoFrmGroup.controls.state.invalid
		);
	}

	isSameAddressChecked() {
		if (!this.isAddressValid()) {
			return false;
		}
		let value = this.infoFrmGroup.getRawValue();
		let addr = `${value.address || ""}${value.address2 || ""}${
			value.city || ""
		}${value.postcode || ""}${value.state || ""}`;
		let deliveryAddr = `${value.deliveryAddress || ""}${
			value.deliveryAddress2 || ""
		}${value.deliveryCity || ""}${value.deliveryPostcode || ""}${
			value.deliveryState || ""
		}`;
		return addr == deliveryAddr;
	}

	addressIsChecked(e: MatCheckboxChange) {
		this.isSameAddressCheck = e.checked;
		let validatorList = e.checked ? [] : [Validators.required];
		if (!e.checked) {
			this.infoFrmGroup.controls.deliveryAddress.reset();
			this.infoFrmGroup.controls.deliveryAddress2.reset();
			this.infoFrmGroup.controls.deliveryCity.reset();
			this.infoFrmGroup.controls.deliveryPostcode.reset();
			this.infoFrmGroup.controls.deliveryState.reset();
		}

		this.infoFrmGroup.controls.deliveryAddress.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryAddress2.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryCity.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryPostcode.setValidators(validatorList);
		this.infoFrmGroup.controls.deliveryState.setValidators(validatorList);

		this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();
		this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
	}

	submit() {
		if (this.agreementFrmGroup.invalid) return;

		this.ngxSpinnerService.show();

		let fd = this.createOrderFormData();

		// [PSSR-1508] Generali E2E Flow:
		//  - GET ORDER API should be exewcuted before payment due to validation on their end
		//  - if validation failed, the quotation should not be allowed to get purchased
		//  - else, customers paid for the quotation yet GET ORDER failed, and unable to proceed to issuance
		//  - and manual handling such quotations tend to have premiums discrepancies

		if (this.isGeneraliIQ) {
			const getOrderInfo: GeneraliGetOrderInfoInterface = {
				address1: this.infoFrmGroup.value.address,
				address2: this.infoFrmGroup.value.address2,
				city: this.infoFrmGroup.value.city
			};

			this.orderDataService
				.processGeneraliOrder(this.quotationId, getOrderInfo)
				.subscribe({
					next: (x: any) => {
						this.ngxSpinnerService.hide();

						if (x.getOrderResult) {
							this.submitOrder(fd);
						} else {
							this.alertService.openSnackBar(
								"Failed to process order, please contact Policy Street."
							);
						}
					},
					error: () => {
						this.ngxSpinnerService.hide();
						this.alertService.openSnackBar(
							"Failed to process order, please contact Policy Street."
						);
					}
				});
		} else {
			this.submitOrder(fd);
		}
	}

	submitOrder(fd: FormData) {
		this.orderDataService.submitOrder(this.id, fd, this.partnerCode).subscribe({
			next: (x) => {
				this.ngxSpinnerService.hide();

				if (this.requestData.isOnlinePayment) {
					window.location.href = x;
				} else {
					let thankyouDialogRef = this.dialog.open(
						ThankyouPurchaseDialogComponent,
						{
							panelClass: "thankyou-purchase-dialog",
							data: {}
						}
					);

					thankyouDialogRef.afterClosed().subscribe((x) => {
						window.location.href = "/quotations";
					});
				}
			},
			error: (err) => {
				this.alertService.openSnackBar(err.error);
				this.ngxSpinnerService.hide();
			}
		});
	}

	getFormArrayControlError(i, formControlName) {
		return (this.getFormArray().controls[i] as UntypedFormGroup).controls[
			formControlName
		].errors;
	}

	benefitDialog(item) {
		this.dialog.open(BenefitDialogComponent, {
			panelClass: "benefit-dialog",
			data: {
				productId: item.productId,
				code: item.code,
				lang: this.translate.currentLang,
				insuranceType: this.requestData.insuranceType
			}
		});
	}

	getAddOnCode(code) {
		return `addOn.${code}`;
	}

	hasAddOn() {
		return (
			this.selectedAddOn.filter(
				(x) => !x.hidePriceBreakdown && x.isIncludeSST
			).length != 0
		);
	}

	addonLabel(value: number) {
		return "RM " + value.toFixed(2).toLocaleString();
	}

	getPrintedQuotation(id: string) {
		this.selectedQuotation = this.quotationList.find((x) => x.id == id);
	}

	print() {
		const printContent = document.getElementById("printOrderSummary");
		const iframe = document?.getElementById("iframePrint") as HTMLIFrameElement;

		if (iframe && printContent) {
			const printWindow = iframe.contentWindow;
			const doc = printWindow?.document;

			if (doc) {
				doc.open();
				doc.writeln(`
					<html>
						<head>
						<style>
							@media print {
								body {
									-webkit-print-color-adjust: exact !important;
									color-adjust: exact !important;
									print-color-adjust: exact !important;
								}
							}
							@page { margin: 0; }
							body { font-family: "Open Sans", sans-serif; }

							.summary-main-container {
								max-width: 900px; 
								height: 100%; 
								padding: 5px 15px; 
								background-color: #c5f2f9; 
								border-radius: 5px;
							}
								.summary-info-header {
									color: #203570; 
									font-size: 18px;
								}
								.summary-info-container {
									background-color: #f4f6fa80; 
									border-radius: 10px; 
									padding: 20px; 
									margin: 5px 0px 15px 0px;
									font-size: 14px;
								}
								.summary-disclaimer {
									font-style: italic; 
									font-size: 13px; 
									margin-top: 5px;
								}
									.summary-disclaimer img {
										width: 15px; 
										margin-right: 8px;
									}
								.summary-footer {
									right: 15px; 
									bottom: 15px;

									&-brand-title {
										font-weight: 600; 
										font-size: 13px;
									}

									&-brand-content {
										font-style: italic;
									}
								}
						</style>
						</head>
						<body>
							${printContent.innerHTML}
						</body>
					</html>
				`);
				doc.close();

				iframe.onload = () => {
					printWindow?.focus();
					printWindow?.print();
				};
			}
		}
	}

	handleFileInput(e, name = null) {
		const files = e.target.files;
		if (files.length) {
			for (let i = 0; i < files.length; i++) {
				let file: File = e.target.files[i];
				if (!FileFunction.isImageOrPdf(file)) {
					this.alertService.openSnackBar(
						`Fail to upload ${file.name} - just accept image type (jpeg, png & svg)`
					);
					return;
				}
				if (!name) {
					this[e.target.name].push(files[i]);
				} else {
					this[e.target.name][name].push(files[i]);
				}
			}
		}

		e.target.value = "";
	}

	handleVideoFileInput(e, name = null) {
		const files = e.target.files;
		if (files.length) {
			for (let i = 0; i < files.length; i++) {
				let file: File = e.target.files[i];
				if (!FileFunction.isVideo(file)) {
					this.alertService.openSnackBar(
						`Fail to upload ${file.name} - just accept video type (mp4, flv & mov)`
					);
					return;
				}
				if (!FileFunction.is20MB(file)) {
					this.alertService.openSnackBar(
						`Fail to upload ${file.name} - just accept video size of 20MB`
					);
					return;
				}
				if (!name) {
					this[e.target.name].push(files[i]);
				} else {
					this[e.target.name][name].push(files[i]);
				}
			}
		}

		e.target.value = "";
	}

	deleteFile(file: any, index: number, name = null) {
		if (!name) {
			this[file].splice(index, 1);
		} else {
			this[file][name].splice(index, 1);
		}
	}

	dealerCaseChanged(e: any) {
		if (e.value) {
			let dialogRef = this.dialog.open(DealerCaseDialogComponent, {
				panelClass: "success-dialog",
				disableClose: true,
				autoFocus: false
			});

			dialogRef.afterClosed().subscribe((x) => {
				if (x) {
					this.infoFrmGroup.patchValue({
						dealerCase: false
					});
				}
			});
		}
	}

	filterAutocompleteList(value: string, list: string[]) {
		if (value) {
			const filterValue = value.toLowerCase();

			return list.filter((x) => x.toLowerCase().includes(filterValue));
		}
		return list;
	}

	getUserDetailsBtnCondition(): boolean {
		if (this.requestData.businessType == "TransferOwnership") {
			if (this.infoFrmGroup.invalid || !this.mykadOrPassport.length || !this.letterOfUndertaking.length)
				return true;
			else {
				if (this.hasSelectedCode("Windshield")) {
					if (!this.vehiclePhoto.length)
						return true;
				}

				if (this.hasSelectedCode("Flood")) {
					if (!this.vehiclePhoto.length || !this.vehicleInteriorPhoto.length || !this.vehicleVideo.length) {
						return true;
					}
				}

				return false;
			}
		} else if (this.requestData.businessType == "Renewal") {
			if (this.infoFrmGroup.invalid) {
				return true;
			} else {
				if (this.hasSelectedCode("Windshield")) {
					if (!this.mykadOrPassport.length || !this.vehiclePhoto.length) {
						return true;
					}
				}
				if (this.hasSelectedCode("Flood")) {
					if (
						!this.mykadOrPassport.length ||
						!this.vehiclePhoto.length ||
						!this.vehicleInteriorPhoto.length ||
						!this.vehicleVideo.length
					) {
						return true;
					}
				}
				return false;
			}
		} else if (this.requestData.businessType == "NewRegister") {
			if (this.infoFrmGroup.invalid) {
				return true;
			} else {
				if (this.hasSelectedCode("Flood")) {
					if (!this.vehicleInteriorPhoto.length || !this.vehicleVideo.length) {
						return true;
					}
				}
				return false;
			}
		} else {
			return true;
		}
	}

	openCarVariantDialog(id: string) {
		let dialogRef = this.dialog.open(CarVariantDialogComponent, {
			panelClass: "edit-quote-dialog",
			data: { requestData: this.requestData, linkId: this.id },
			autoFocus: false
		});

		dialogRef.afterClosed().subscribe((result: any) => {
			if (result && result.data === true) {
				this.selectQuotation(id);
			}
		});
	}

	getLinkToCustomer() {
		let link = this.router.url;
		let hostName = window.location.origin;
		let linkToCustomer = hostName + link;

		this.clipboard.copy(linkToCustomer.replace("u/", ""));
		this.alertService.openSnackBar(`Link copied to your clipboard`);
	}

	updateSelectedInsurers(id: string) {
		const index = this.selectedOtherInsurers.indexOf(id);
		if (index === -1) {
			this.selectedOtherInsurers.push(id);
		} else {
			this.selectedOtherInsurers.splice(index, 1);
		}
	}

	submitOtherInsurer() {
		let typeOfSum = this.requestData?.typeOfSum ?? "MV";

		this.orderDataService
			.submitExtraProduct(this.id, typeOfSum, this.selectedOtherInsurers)
			.subscribe({
				next: (x) => {
					this.handleSuccessSubmitQuotation({
						preferredChannel: this.requestData?.preferredChannel,
						email: this.requestData?.email,
						mobileNo: this.requestData?.mobileNo
					});
				}
			});
	}

	private handleSuccessSubmitQuotation(
		customerInput: Partial<MotorQuotationInterface>
	): void {
		const dialogRef = this.dialog.open(SubmitSuccessDialogComponent, {
			panelClass: "success-dialog",
			maxWidth: "500px",
			data: { customerInput }
		});

		dialogRef.afterClosed().subscribe(() => location.reload());
	}

	private getAdditionalInsurer() {
		this.orderDataService.GetAvailableProductByLinkId(this.id).subscribe({
			next: (x: OtherInsurerInterface[]) => {
				this.otherInsurerList = x;
			},
			error: () => {
				// window.location.href = "/";
			}
		});
	}

	saveOrder() {
		this.ngxSpinnerService.show();

		let fd = this.createOrderFormData();

		this.orderDataService.saveOrder(this.id, fd, this.partnerCode).subscribe({
			next: () => {
				this.alertService.openSnackBar("Order saved as draft.");
				this.ngxSpinnerService.hide();
			},
			error: (err) => {
				this.alertService.openSnackBar(err.error);
				this.ngxSpinnerService.hide();
			}
		});
	}

	createOrderFormData() {
		let fd = new FormData();

		fd.append("QuotationId", this.quotationId);
		if (
			this.selectedAddOn.find((e) => e.category == "Windshield") &&
			this.addOnFrmGroup.value.windshield
		) {
			fd.append("WindShield", this.addOnFrmGroup.value.windshield);
		}
		if (
			this.selectedAddOn.find((e) => e.category == "FGAP") &&
			this.fgapAddOnsIndex
		) {
			fd.append("Fgap.Value", this.fgapAddOnsIndex);
		}
		if (
			this.selectedAddOn.find((e) => e.category == "FGAP") &&
			this.addOnFrmGroup.value.fgap
		) {
			fd.append("Fgap.Amount", this.addOnFrmGroup.value.fgap);
		}

		fd.append("Occupation", this.infoFrmGroup.value.occupation);
		fd.append("Address", this.infoFrmGroup.value.address);
		fd.append("Address2", this.infoFrmGroup.value.address2);
		fd.append("City", this.infoFrmGroup.value.city);
		fd.append("State", this.infoFrmGroup.value.state);

		if (
			this.infoFrmGroup.value.deliveryAddress != undefined &&
			this.infoFrmGroup.value.deliveryAddress != null
		)
			fd.append("DeliveryAddress", this.infoFrmGroup.value.deliveryAddress);

		if (
			this.infoFrmGroup.value.deliveryAddress2 != undefined &&
			this.infoFrmGroup.value.deliveryAddress2 != null
		)
			fd.append("DeliveryAddress2", this.infoFrmGroup.value.deliveryAddress2);

		if (
			this.infoFrmGroup.value.deliveryCity != undefined &&
			this.infoFrmGroup.value.deliveryCity != null
		)
			fd.append("DeliveryCity", this.infoFrmGroup.value.deliveryCity);

		if (
			this.infoFrmGroup.value.deliveryPostcode != undefined &&
			this.infoFrmGroup.value.deliveryPostcode != null
		)
			fd.append("DeliveryPostcode", this.infoFrmGroup.value.deliveryPostcode);

		if (
			this.infoFrmGroup.value.deliveryState != undefined &&
			this.infoFrmGroup.value.deliveryState != null
		)
			fd.append("DeliveryState", this.infoFrmGroup.value.deliveryState);

		fd.append(
			"IncludeRoadTax",
			this.addOnFrmGroup.value.isIncludeRoadtax ?? "false"
		);
		fd.append(
			"IncludeDigitalRoadTax",
			this.isIncludeDigitalRoadtax ? "true" : "false"
		);
		fd.append("Name", this.infoFrmGroup.value.name);
		fd.append("Email", this.infoFrmGroup.value.email);
		fd.append("MobileNo", this.infoFrmGroup.value.mobileNo);
		fd.append("FinanceType", this.infoFrmGroup.value.financingType);

		if (this.infoFrmGroup.value.bank) {
			fd.append("HirePurchase", this.infoFrmGroup.value.bank);
		}
		if (this.infoFrmGroup.value.effectiveDate) {
			fd.append(
				"HirePurchaseEffectiveDate",
				this.infoFrmGroup.value.effectiveDate.toISOString()
			);
		}

		if (
			this.selectedAddOn.find((e) => e.code == "AdditionalDrivers") &&
			this.addOnFrmGroup.value.drivers
		) {
			this.addOnFrmGroup.value.drivers.map((x, i) => {
				fd.append(
					`AdditionalDriverList[${i}].Dob`,
					x.dob instanceof Date ? x.dob.toISOString() : x.dob
				);
				fd.append(`AdditionalDriverList[${i}].Gender`, x.gender);
				fd.append(`AdditionalDriverList[${i}].IdType`, x.idType);
				fd.append(`AdditionalDriverList[${i}].IdentityNo`, x.identityNo);
				fd.append(`AdditionalDriverList[${i}].MaritalStatus`, x.maritalStatus);
				fd.append(`AdditionalDriverList[${i}].Name`, x.name);
				fd.append(`AdditionalDriverList[${i}].Relationship`, x.relationship);
				fd.append(`AdditionalDriverList[${i}].IsMalaysian`, x.isMalaysian);
			});
		}

		if (this.selectedAddOn.length) {
			this.selectedAddOn.map((x, i) => {
				fd.append(`AddOnIds[${i}]`, x.id);
			});
		}

		if (this.mykadOrPassport.length) {
			fd.append("FileList[0].type", "ID");
			this.mykadOrPassport.forEach((x) => {
				fd.append(`FileList[0].files`, x);
			});
		}

		if (this.letterOfUndertaking.length) {
			fd.append("FileList[1].type", "LOU");
			this.letterOfUndertaking.forEach((x) => {
				fd.append(`FileList[1].files`, x);
			});
		}

		if (this.requestData.businessType == "Renewal") {
			if (this.vehiclePhoto.length) {
				fd.append("FileList[1].type", "VehiclePhoto");
				this.vehiclePhoto.forEach((x) => {
					fd.append(`FileList[1].files`, x);
				});
			}

			if (this.vehicleInteriorPhoto.length) {
				fd.append("FileList[2].type", "VehicleInteriorPhoto");
				this.vehicleInteriorPhoto.forEach((x) => {
					fd.append(`FileList[2].files`, x);
				});
			}

			if (this.vehicleVideo.length) {
				fd.append("FileList[3].type", "VehicleVideo");
				this.vehicleVideo.forEach((x) => {
					fd.append(`FileList[3].files`, x);
				});
			}
		} else {
			if (this.vehiclePhoto.length) {
				fd.append("FileList[2].type", "VehiclePhoto");
				this.vehiclePhoto.forEach((x) => {
					fd.append(`FileList[2].files`, x);
				});
			}

			if (this.vehicleInteriorPhoto.length) {
				fd.append("FileList[3].type", "VehicleInteriorPhoto");
				this.vehicleInteriorPhoto.forEach((x) => {
					fd.append(`FileList[3].files`, x);
				});
			}

			if (this.vehicleVideo.length) {
				fd.append("FileList[4].type", "VehicleVideo");
				this.vehicleVideo.forEach((x) => {
					fd.append(`FileList[4].files`, x);
				});
			}
		}

		fd.append("PaymentProvider", this.paymentData.paymentProvider);
		fd.append("PaymentType", this.paymentData.paymentType);

		let paymentChannel = this.paymentData.paymentChannel;

		if (this.paymentData.paymentChannel == PAYMENT_OPTION_EWALLET) {
			paymentChannel = this.paymentData.ewalletType;
		}

		if (this.paymentData.paymentChannel == PAYMENT_OPTION_FPX_ENTERPRISE) {
			paymentChannel = this.paymentData.fpxEnterpriseType;
		}

		if (this.paymentData.paymentOptionType == PAYMENT_OPTION_SHOPBACK) {
			paymentChannel = PAYMENT_OPTION_SHOPBACK;
		}

		fd.append("PaymentChannel", paymentChannel);
		fd.append(
			"InstallmentMonth",
			this.paymentData.installmentMonth == null
				? "0" //Default to 0 is Backend API requirement
				: this.paymentData.installmentMonth.toString()
		);
		fd.append(
			"Seat",
			this.numberOfLltpSeats == null ? "0" : this.numberOfLltpSeats.toString()
		);

		if (this.promo?.id != null && typeof (this.promo?.id != undefined)) {
			fd.append("PromoCodeId", this.promo?.id);
		}

		if (
			this.selectedAddOn.find((e) => e.category == "CART") &&
			this.addOnFrmGroup.value.cartDays &&
			this.addOnFrmGroup.value.cartDailyCoverage
		) {
			fd.append("cartDays", this.addOnFrmGroup.value.cartDays);
			fd.append(
				"cartDailyCoverage",
				this.addOnFrmGroup.value.cartDailyCoverage
			);
		}

		if (
			this.selectedAddOn.find((e) => e.category == "GCKT") &&
			this.addOnFrmGroup.value.gckt
		) {
			fd.append("gckt", this.addOnFrmGroup.value.gckt);
		}

		if (
			this.selectedAddOn.find((e) => e.category == "VA") &&
			this.addOnFrmGroup.value.va
		) {
			fd.append("va", this.addOnFrmGroup.value.va);
		}

		fd.append("insuranceType", this.requestData.insuranceType);

		return fd;
	}

	getMinMaxWindscreenPrice(
		addOn: ProductAddOnInterface,
		key: "min" | "max"
	): number {
		const rule = this.getRule(addOn);
		const { maxWindshieldPrice, minWindshieldPrice } = this.selectedQuotation;

		const config = {
			max: maxWindshieldPrice || rule?.max || 10000,
			min: minWindshieldPrice || rule?.min || 500
		};

		return config[key];
	}

	getPartnerLogo() {
		if (this.partnerCode == "carsomeCapital")
			return "https://storage.googleapis.com/ps-asset/ps_logos/ps_carsome_logo.png";
		else
			return "https://storage.googleapis.com/ps-asset/ps_logos/ps_digirep_logo.png";
	}

	private getCARTAddOnPriceList() {
		this.orderDataService.getCARTAddOnPriceList().subscribe({
			next: (x: MotorAddOnCARTPriceInterface[]) => {
				this.cartAddOnPriceList = x;
			}
		});
	}
}
